import { IResponse } from "@/types";
import { post } from "../api-config";
import { API_ENDPOINTS } from "../api-endpoints";
import { ILogin } from "./types";

export const login = (payload: ILogin): Promise<IResponse> => {
  return new Promise((resolve, reject) => {
    post(API_ENDPOINTS.AUTH.LOGIN, payload)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
